import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const ListCourseBox = withTheme(styled(Box)`
  justify-content: space-between;
  padding: 24px;
  gap: 24px;
  display: flex;
  flex-direction: row;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;

  @media only screen and (max-width: 1199px) and (min-width: 768px) {
    padding: 24px;
    gap: 14px;
  }

  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }

  .course-info-box {
    height: fit-content;
    width: 74%;
    gap: 8px;
    align-items: flex-start;
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      height: fit-content;
      width: 100%;
      flex-direction: column;
      gap: 8px;
    }

    @media only screen and (max-width: 767px) {
      height: fit-content;
      width: 100%;
      flex-direction: column;
      gap: 8px;
    }
  }

  .title-text {
    width: 344px;
    font-weight: 600;
    line-height: 22px;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      width: fit-content;
    }

    @media only screen and (max-width: 767px) {
      width: fit-content;
    }
  }

  .round-info-box {
    width: 288px;
    height: 66px;
    display: flex;
    flex-direction: column;
  }

  .round-date-text {
    font-size: 18px;
    line-height: 22px;
  }

  .choose-round-button {
    width: 224px;
    height: 40px;
    color: ${({ isSelectRound, theme }: any) => (isSelectRound ? theme.secondaryCPD : '#ffffff')};
    border-radius: 4px;
    align-self: center;

    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  .calendar-icon {
    height: 15px;
    width: 15px;
  }
`);
